import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { deletetodo, edittodo } from './action'

const ToDo = ({id,title}) => {
  let [editing,setediting]=useState(false)
  let [newtitle,setnewtitle]=useState(title)
  let dispatch=useDispatch()
  let handletodo=()=>{
      if(newtitle.trim()){
        dispatch(edittodo({id:id,title:newtitle}))
      }
  }
  let handleDelete=()=>{
    console.log("hii");
    dispatch(deletetodo(id))
  }
  return (
    <>
    <div style={{display:"flex",justifyContent:"center"}}>
      {
        editing?(
         <div className='form-group'>
            <input type="text" className='form-control' name="" id="" value={newtitle} onChange={(e)=>setnewtitle(e.target.value)}/>
            <button className='btn btn-secondary' onClick={()=>{handletodo()}}>SAVE</button>
         </div>
        )
        :
        (
          <li className='list-group-item'>
            <p>{title}</p>
            <div className='actions'>
              <button className='btn btn-warning' onClick={()=>setediting(true)}>EDIT</button>
              <button className='btn btn-danger' onClick={handleDelete}>DELETE</button>
            </div>
          </li>
        )
      }
    </div>
    </>
  )
}

export default ToDo